<template>
  <aicc-page :pageId="contextPageId" :titleShow="false">
    <div class="-page-header">
      <!-- <div class="-page-header-title__wrapper"> -->
        <div class="-page-header-title-main__wrapper">
          <h1 class="-page-header-title-main__title">시나리오 상세</h1>
        </div>
      <!-- </div> -->
    </div>
    <ur-area>
      <!-- 시나리오 정보 -->
      <div class="inquiry_scenario_pop">
        <div class="box_gray">
          <dl>
            <dt><strong :class="statusClass(scenarioInfo.statusCode)">{{getStatus(scenarioInfo.statusCode)}}</strong> {{scenarioInfo.scenarioName}}</dt>
            <dd><strong>요청자</strong>{{scenarioInfo.fstRgstUsrNm}}</dd>
            <dd><strong>담당 큐레이터</strong>{{getCurator(scenarioInfo) || assigning}}</dd>
            <dd><strong>요청일자</strong>{{changeDateformat(scenarioInfo.fstRgstDtm)}}</dd>
            <dd><strong>완료일자</strong>{{changeDateformat(scenarioInfo.completionDate) || incomplete + '&ensp;&ensp;&ensp;&ensp;&ensp;'}}</dd>
          </dl>
        </div>
      </div>
      <!-- 조회 조건 -->
      <ur-form-box toggleable column="5">
        <ur-form-row>
          <ur-form-item label="적용일자" :vertical="false" labelAlign="right" colSpan="2">
            <aicc-range-picker v-model="rangePickerValue" inputType="YYYY-MM-DD" modelType="YYYY-MM-DD" Name init="none" autoConfirm />
          </ur-form-item>
          <ur-form-item label="발화조건" :vertical="false" labelAlign="right" colSpan="2">
            <ur-dropdown v-model="scriptAsk.speechCondition" :items="speechConditionItems"/>
          </ur-form-item>
        </ur-form-row>
        <ur-form-row>
          <ur-form-item label="발화그룹" :vertical="false" labelAlign="right" colSpan="2">
            <ur-dropdown v-model="scriptAsk.scriptGroupCode" :items="scriptGroupCodeItems"/>
          </ur-form-item>
          <ur-form-item label="질문 키워드" :vertical="false" labelAlign="right" colSpan="2">
            <ur-text-field v-model="scriptAsk.script" placeholder="키워드 입력" :disabled="false" :clearable="true" :readonly="false" :width="300" @blur="onBlurTrim"/>
          </ur-form-item>
          <ur-form-item no-label noFlex>
            <ur-button shape="solid" primary @click="onClickSearch()">조회</ur-button>
          </ur-form-item>
        </ur-form-row>
      </ur-form-box>
      <!-- 스크립트 리스트 -->
      <div class="data_tbl_list">
        <ur-data-grid :headers="headers" :options="options" :data-source="dataList" ref="grid" @grid:click="clickEvent" @grid:selected="selectRow" >
          <template #right-info>
            <ur-button v-if="isNew" shape="solid" color="white" @click="onClickAttachmentDownload()">첨부 파일 다운로드</ur-button>
            <span v-if="isNew" class="my-divider"> | </span>
            <ur-button shape="solid" color="white" @click="onClickVariable()">변수 조회</ur-button>
            <span class="my-divider"> | </span>
            <ur-button shape="solid" color="white" @click="onClickScriptListDownload()">데이터 다운로드</ur-button>
            <ur-button primary icon="monitor" :disabled="!scenarioInfo.testable" @click="onClickTest()">테스트 실행</ur-button>
          </template>
        </ur-data-grid>
      </div>
      <!-- 변수 조회 모달 -->
      <ur-modal ref="variableModal" :title="'변수 조회'" :width="703" :height="494" style="z-index:1000">
        <variable-table style="margin-bottom:20px" :headers="variableHeaders" :items="variableItems" />
        <ur-button shape="hyperlink" style="z-index:1000; padding: 0 4px; color:#516af4;" @click="onClickVariableDownload()">변수목록 다운로드</ur-button>
        <div style="float:right">
          <ur-button shape="solid" primary style="z-index:1000" @click="closeVariableModal()">확인</ur-button>
        </div>
      </ur-modal>
      <!-- 테스트 실행 모달 -->
      <!-- <ur-modal ref="confirmModal">
        <div>
          {{firstScript}}부터 시나리오 테스트를 진행하시겠습니까?
        </div>
        <ur-button @click="closeConfirmModal()" >취소</ur-button>
        <ur-button shape="solid" color="primary" @click="onClickTest()" >확인</ur-button>
      </ur-modal> -->
      <!-- 대화 상세정보 모달 -->
      <script-modal
        ref="scriptModal"
        :parentPageId="contextPageId"
        :scenarioId="scriptAsk.scenarioId"
        :scenarioInfo="scenarioInfo"
        :variableHeaders="variableHeaders"
        :variableItems="variableItems"
        :queries="queries"
        :speechConditionItems="speechConditionItems"
        :scriptGroupCodeItems="scriptGroupCodeItems"
        :scenarioModifying="scenarioModifying"
        @complete="onComplete()"
      />
      <!-- 스낵바 -->
      <ur-snackbar ref="snackbar" :duration="3000"/>
    </ur-area>
  </aicc-page>
</template>

<script>
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';
import BasePage from '~cm/components/BasePage';
import CMP_AID_00001 from '../../components/CMP_AID_00001';
import CMP_AID_00002 from '../../components/CMP_AID_00002';

export default {
  name: 'PGE_AID_00002', // eslint-disable-line vue/name-property-casing
  components: {
    scriptModal: CMP_AID_00001,
    variableTable: CMP_AID_00002,
    urDataGrid,
  },
  extends: BasePage,
  data() {
    return {
      // 데이터 그리드
      dataList: [],
      items: [],
      headers: [
        { text: '대화ID', value: 'scriptId', width: '76px', sort: false },
        { text: '시스템코드', value: 'managedScriptId', width: '98px', sort: false },
        { text: '발화조건', value: 'speechConditionName', width: '244px', sort: false },
        { text: '발화그룹', value: 'scriptGroupName', width: '98px', sort: false },
        { text: 'AI 발화문장', value: 'script', sort: false },
        { text: '답변유형', value: 'answerType', width: '68px', sort: false },
        { text: '적용 시작일', value: 'effectiveDate', width: '104px', sort: false },
        { text: '적용 종료일', value: 'expirationDate', width: '98px', sort: false },
      ],
      selected: [],
      page: {
        rowsPerPage: 50,
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
      },
      options: {
        msgTotal: '총 #',
        msgPerPage: '#건씩 보기',
        msgAscending: '오름차순 정렬',
        msgDescending: '내림차순 정렬',
        multiSelect: true,
        // selectCheck: true,
        selectCheckOnly: true,
        pagination: true,
        internalPaging: true,
        defaultPageSize: 50,
        pagingList: [10, 50, 100, 200, 300],
        height: 500,
        msgEmptyData: '', // 조회 완료 후에 문구 출력
      },

      // 시나리오 정보
      scenarioInfo: {
        scenarioType: '',
        statusCode: '',
        scenarioName: '',
        fstRgstUsrId: '',
        fstRgstUsrNm: '',
        curatorUsrId: '',
        curatorUsrNm: '',
        fstRgstDtm: '',
        completionDate: '',
        testable: false,
      },
      incomplete: '',
      assigning: '',

      // 조회조건
      scriptAsk: {
        scenarioId: '',
        effectiveDate: '',
        expirationDate: '',
        script: '',
        speechCondition: '',
        scriptGroupCode: '',
      },
      rangePickerValue: ['', ''],

      // 발화조건
      speechConditionItems: [
        {
          text: '전체',
          value: '',
        },
      ],

      // 발화그룹
      scriptGroupCodeItems: [
        {
          text: '전체',
          value: '',
        },
      ],

      // 변수조회
      variableOptions: {
        noBaseInfo: true,
        infinityScroll: true,
        rowHeight: 35,
        height: 350,
      },
      variableHeaders: [
        { text: '변수명', value: 'variableMeaning' },
        { text: '변수값', value: 'variableExp' },
        { text: '예시', value: 'description' },
      ],
      variableItems: [],
      queries: [], // 등록된 변수

      // 테스트 실행
      // firstScript: '',
      testAsk: {
        scenarioId: '',
      },

      // 윈도우 팝업
      popupWindow: null,
      testWindowOptions: 'width=386,height=853,location=no,menubar=no,status=no,toolbar=no,resizable=yes',

      // 다운로드
      fileType: 'text/csv;charset=utf-8',
      fileList: [],

      // 시나리오 동시 수정 제한
      scenarioModifying: {
        usrId: '',
        usrNm: '',
        isModifying: true,
      },
      timerId: -1, // setTimeout 리턴 값 저장, setTimeout 리턴 값은 양수이기 때문에 -1로 초기화(setTimeout 되지 않은 상태)
      refreshTimeValue: '60000', // 60,000ms
      refreshCount: 0,
      refreshMaxCount: 10,
    };
  },
  computed: {
    // testDisabled() {
    //   if (this.selected.length > 0) {
    //     return false;
    //   }
    //   return true;
    // },
    variableDownloadData() {
      const headerIndexArr = [0, 1, 2];
      const dataString = aiccUtils.stringUtil.tableToCsvDataString(this.variableHeaders, this.variableItems, headerIndexArr);
      return dataString;
    },
    scriptListDownloadData() {
      const headerIndexArr = [0, 1, 2, 3, 4, 5, 6, 7];
      const dataString = aiccUtils.stringUtil.tableToCsvDataString(this.headers, this.dataList, headerIndexArr);
      return dataString;
    },

    // 시나리오 구분 : A(표준), B(신규)
    isNew() {
      if (this.scenarioInfo.scenarioType === 'B') {
        return true;
      }
      return false;
    },
  },
  watch: {
    rangePickerValue() { // 적용일자 선택시 나머지 조회조건 초기화.단, 동일한 적용일자 선택시 초기화하지 않음
      this.scriptAsk.speechCondition = '';
      this.scriptAsk.scriptGroupCode = '';
      this.scriptAsk.script = '';
    },
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      this.scriptAsk.scenarioId = utils.getParameter(this, 'scenarioId');
      this.testAsk.scenarioId = utils.getParameter(this, 'scenarioId');
      this.addWindowEventListener();
      this.startModifyingScenario();
      this.getSpeechConditionItems(this.scriptAsk.scenarioId);
      this.getScriptGroupCodeItems(this.scriptAsk.scenarioId);
      this.getScenarioInfo(this.scriptAsk.scenarioId);
      this.getVariable(this.scriptAsk.scenarioId);
      this.onClickSearch();
    },

    // 발화조건 리스트 조회
    getSpeechConditionItems(value) {
      const codeAsk = {
        scenarioId: value,
        codeType: 'AA',
      };
      http.request(this.contextPageId, 'DTS_AID_00002', {
        data: codeAsk,
      }).then(res => {
        for (var item in res.data.codeList) {
          this.speechConditionItems.push(
            {
              text: res.data.codeList[item].codeName,
              value: res.data.codeList[item].codeValue,
            }
          );
        }
      });
    },

    // 발화그룹 리스트 조회
    getScriptGroupCodeItems(value) {
      const codeAsk = {
        scenarioId: value,
        codeType: 'AB',
      };
      http.request(this.contextPageId, 'DTS_AID_00002', {
        data: codeAsk,
      }).then(res => {
        for (var item in res.data.codeList) {
          this.scriptGroupCodeItems.push(
            {
              text: res.data.codeList[item].codeName,
              value: res.data.codeList[item].codeValue,
            }
          );
        }
      });
    },
    
    // 큐레이터
    getCurator(item) {
      if (item.email == null || item.email === '') {
        return item.curatorUsrNm;
      }

      return `${item.curatorUsrNm}(${item.email})`;
    },

    // 시나리오 정보 조회
    getScenarioInfo(value) {
      const scenarioAsk = {
        scenarioId: value,
      };
      http.request(this.contextPageId, 'DTS_AID_00007', {
        data: scenarioAsk,
      }).then(res => {
        this.scenarioInfo = res.data.scenario;
        this.incomplete = '미완료';
        this.assigning = '배정중';
        utils.forEach(res.data.fileList, file => {
          if (file.fileExist) {
            this.fileList.push(file);
          }
        });
      });
    },

    // 변수 조회
    getVariable(value) {
      const scenarioAsk = {
        scenarioId: value,
      };
      http.request(this.contextPageId, 'DTS_AID_00009', {  
        data: scenarioAsk,
      }).then(res => {        
        this.variableItems = res.data.variableList;
        for (var item in res.data.variableList) {
          this.queries.push(res.data.variableList[item].variableExp);
        }
      });
    },
    onClickVariable() {
      this.$refs.variableModal.open();
    },
    closeVariableModal() {
      this.$refs.variableModal.close();
    },

    // 스크립트 조회
    onBlurTrim() {
      this.scriptAsk.script = this.scriptAsk.script.trim();
    },
    onClickSearch() {
      // 적용일자
      this.scriptAsk.effectiveDate = utils.toStringByFormat(utils.toDate(this.rangePickerValue[0]), 'YYYYMMDD');
      this.scriptAsk.expirationDate = utils.toStringByFormat(utils.toDate(this.rangePickerValue[1]), 'YYYYMMDD');
      
      http.request(this.contextPageId, 'DTS_AID_00008', {
        data: this.scriptAsk,
      }).then(res => {        
        let rowList = []; // 화면용 list 
        for (var script of res.data.scriptList) {
          // row list 채움
          let row = {};
          row.scriptId = script.scriptId;
          row.managedScriptId = script.managedScriptId;
          row.speechConditionName = script.speechConditionName;
          row.scriptGroupName = script.scriptGroupName;
          row.script = script.script;
          row.answerType = this.getAnswerType(script.answerType);
          row.effectiveDate = this.changeDateformat(script.effectiveDate);
          row.expirationDate = this.changeDateformat(script.expirationDate);

          rowList.push(row);
        }

        this.dataList = rowList; // row list를 화면용 list에 넘김        
        this.options.msgEmptyData = '선택하신 조건의 조회결과가 없습니다.';
        this.$refs.grid.setCurrentPage(1);
      });
    },

    // 메인화면을 종료할 때, 시나리오 수정 권한 반환, 윈도우 팝업을 모두 종료
    addWindowEventListener() {
      window.addEventListener('beforeunload', this.endModifyingScenarioAndCloseWindowPopup);
    },
    endModifyingScenarioAndCloseWindowPopup() {
      this.endModifyingScenario();
      this.closeWindowPopup();
    },
    closeWindowPopup() { // 메인화면을 종료할 때, 윈도우 팝업을 모두 종료
      if (this.popupWindow != null) {
        this.popupWindow.close();
      }
    },

    // 시나리오 동시 수정 제한
    startModifyingScenario() {
      console.log('startModifyingScenario');
      const dataParams = {
        scenarioId: this.scriptAsk.scenarioId,
      };
      http.request(this.contextPageId, 'DTS_AID_00023', {
        data: dataParams,
      }).then(res => {
        if (res.data.reply.code === '0000') { // 수정 가능
          this.scenarioModifying.isModifying = false;
          if (this.timerId !== -1) {
            clearTimeout(this.timerId);
          }
          this.timerId = setTimeout(this.keepModifyingScenario, this.refreshTimeValue);
        } else { // 수정 불가
          if (res.data.reply.code === '2020') { // 다른 사용자 수정
            this.scenarioModifying.usrId = res.data.scenarioModifyingUser.usrId;
            this.scenarioModifying.usrNm = res.data.scenarioModifyingUser.usrNm;
            utils.aiccMessageBox('확인', `${this.scenarioModifying.usrNm}님이 현재 수정 중인 시나리오입니다.`, '확인', null);
          } else if (res.data.reply.code !== '2005') { // 운영중 외 기타 오류
            utils.aiccMessageBox('확인', res.data.reply.korMsg, '확인', null);
          }
        }
      });
    },
    keepModifyingScenario() {
      this.refreshCount++;
      console.log(`keepModifyingScenario : ${this.refreshCount}`);
      if (this.refreshCount > this.refreshMaxCount) {
        clearTimeout(this.timerId);
        utils.aiccMessageBox('알림', '서버 오류로 연결이 종료되었습니다.',
          '확인', () => {
            window.close();
          });
        return;
      }
      this.timerId = setTimeout(this.keepModifyingScenario, this.refreshTimeValue);
      const dataParams = {
        scenarioId: this.scriptAsk.scenarioId,
      };
      http.request(this.contextPageId, 'DTS_AID_00024', {
        data: dataParams,
      }).then(res => {
        if (res.data.reply.code === '0000') {
          this.refreshCount = 0;
        }
      });
    },
    endModifyingScenario() {
      console.log('endModifyingScenario');
      const dataParams = {
        scenarioId: this.scriptAsk.scenarioId,
      };
      http.request(this.contextPageId, 'DTS_AID_00025', {
        data: dataParams,
      });
    },
    // 테스트 실행
    // onClickConfirmModal() {
    //   this.selected.sort((a, b) => {
    //     if (a.scriptId > b.scriptId) {
    //       return 1;
    //     }
    //     if (a.scriptId < b.scriptId) {
    //       return -1;
    //     }
    //     return 0;
    //   });
    //   this.firstScript = this.selected[0].scriptId;
    //   this.$refs.confirmModal.open();
    // },
    onClickTest() {
      // this.$refs.confirmModal.close();
      http.request(this.contextPageId, 'DTS_AID_00003', {
        data: this.testAsk,
      }).then(res => {
        if (res.data.reply.code === '0000') {
          if (this.popupWindow != null && this.popupWindow.closed === false) { // 중복 팝업
            this.popupWindow.close(); // 중복 팝업시 종료 후 재실행
          }
          const centerPopupOption = aiccUtils.popupUtil.getCenterPopupOption(this.testWindowOptions);
          this.popupWindow = window.open(res.data.webchatUrl, '', centerPopupOption);
        } else {
          utils.aiccMessageBox('확인', res.data.reply.korMsg, '확인', null);
        }
      });
    },
    // closeConfirmModal() {
    //   this.$refs.confirmModal.close();
    // },

    // 다운로드
    onClickVariableDownload() {
      const url = aiccUtils.fileDownload.getBlobUrl(this.variableDownloadData, this.fileType);
      const fileName = `${this.scenarioInfo.scenarioName}_변수목록.csv`;
      const fileDownloadHistoryAsk = {
        pageId: this.contextPageId,
        fileName: fileName,
        fileDetail: `Scenario ID : ${this.scriptAsk.scenarioId}`,
      };

      http.request(this.contextPageId, 'DTS_AIZ_00001', {
        data: fileDownloadHistoryAsk,
      }).then(res => {
        if (res.status === 200) {
          aiccUtils.fileDownload.download(url, fileName);
        } else {
          utils.aiccMessageBox('알림', '잠시 후 다시 시도해주세요.', '확인', null);
        }
      }).catch(error => {
        console.warn(error);
      });
    },
    onClickScriptListDownload() {
      const url = aiccUtils.fileDownload.getBlobUrl(this.scriptListDownloadData, this.fileType);
      const fileName = `${this.scenarioInfo.scenarioName}_데이터.csv`;
      const fileDownloadHistoryAsk = {
        pageId: this.contextPageId,
        fileName: fileName,
        fileDetail: `Scenario ID : ${this.scriptAsk.scenarioId}`,
      };

      http.request(this.contextPageId, 'DTS_AIZ_00001', {
        data: fileDownloadHistoryAsk,
      }).then(res => {
        if (res.status === 200) {
          aiccUtils.fileDownload.download(url, fileName);
        } else {
          utils.aiccMessageBox('알림', '잠시 후 다시 시도해주세요.', '확인', null);
        }
      }).catch(error => {
        console.warn(error);
      });
    },
    onClickAttachmentDownload() {
      if (this.fileList.length === 0) {
        utils.aiccMessageBox('알림', '첨부 파일은 요청일자로부터 6개월간 다운로드 가능합니다.', '확인', null);
        return;
      }
      utils.forEach(this.fileList, file => {
        const fileDownloadHistoryAsk = {
          pageId: this.contextPageId,
          fileName: file.filename,
          fileDetail: `Scenario ID : ${this.scriptAsk.scenarioId}/SR ID : ${file.srId}`,
        };
        http.request(this.contextPageId, 'DTS_AIZ_00001', {
          data: fileDownloadHistoryAsk,
        }).then(historyRes => {
          if (historyRes.status === 200) {
            const queryParams = {
              srId: file.srId,
              fileId: file.fileId,
              filename: file.filename,
            };
            http.request(this.contextPageId, 'DTS_AID_00022', {
              query: queryParams,
            }).then(downloadRes => {
              aiccUtils.fileDownload.downloadBase64(downloadRes.data.file.file, queryParams.filename, downloadRes.data.file.fileType);
            });
          } else {
            utils.aiccMessageBox('알림', '잠시 후 다시 시도해주세요.', '확인', null);
          }
        }).catch(error => {
          console.warn(error);
        });
      });
    },

    // 고객답변유형 코드 -> 텍스트
    getAnswerType(answerType) {
      return aiccCode.answerType.codeText(answerType);
    },

    // 시나리오 상태 코드 -> 텍스트
    getStatus(statusCode) {
      return aiccCode.scenarioServiceRequestStatus.codeText(statusCode);
    },

    // 상태별 CSS 적용
    statusClass(value) {
      return {
        A: 'status lg ing', // green
        B: 'status lg waiting', // orange
        C: 'status lg waiting', // orange
        D: 'status lg done', // blue
        E: 'status lg cancel', // grey
        F: 'status lg cancel', // grey
      }[value] || 'status lg cancel'; // default
    },

    // 일자 형식 YYYYMMDD -> YYYY-MM-DD
    changeDateformat(date) {
      return utils.dateformatToClient(date, 'S');
    },

    // 데이터 그리드
    clickEvent(cell, row, field, e) {
      if (typeof e === 'object') {
        if (e.button === 0) { // 마우스 메인 버튼만 유효
          if (field.value !== 'checkbox') { // 체크박스 제외
            this.$refs.scriptModal.open(row.scriptId);
          }
        }
      }
    },
    selectRow(sels) {
      this.selected = sels;
    },

    // AI 발화문장 수정 성공
    onComplete() {
      this.onClickSearch();
      this.showSnackbar('AI 발화문장이 저장되었습니다.');
    },
    showSnackbar(message) {
      this.$nextTick(() => {
        this.$refs.snackbar.show({ text: message });
      });
    },
  },
};
</script>

<style scoped>
/*시나리오상세조회*/
.inquiry_scenario_pop .status {min-width: 60px;}
.inquiry_scenario_pop .box_gray {margin-top: 20px; margin-bottom: 20px; margin-left:0px; margin-right: 0px;}
.inquiry_scenario_pop .box_gray dt:after {display:none}
.inquiry_scenario_pop .box_gray dt .status {margin-right: 16px;}
.inquiry_scenario_pop .box_gray dl dd {position: relative;flex-grow: 0;}
.inquiry_scenario_pop .box_gray dl dt + dd {margin-left: auto}
.inquiry_scenario_pop .box_gray dl dd strong {display:inline-block; margin-right: 8px}
.inquiry_scenario_pop .box_gray dl dd + dd {margin-left: 16px; padding-left: 16px}
.inquiry_scenario_pop .box_gray dl dd + dd:before {display: inline-block; content: ''; width: 1px; height: 16px;  background: #ddd;  position: absolute;  top: 50%;  margin-top: -6px;  left: 0;}
.inquiry_scenario_pop .box_gray dl dd + dd:last-child {margin-left: 12px; padding-left: 0}
.inquiry_scenario_pop .box_gray dl dd + dd:last-child:before {display:none}
.inquiry_scenario_pop .search_box {margin-top: 20px; margin-bottom: 20px}
.inquiry_scenario_pop .data_tbl_list td {line-height: 1.5;}
.inquiry_scenario_pop .data_tbl_info .btn_l {min-width: 208px;}

.ur-dropdown {width: 300px;}

/*데이터 그리드 mousehover pointer 적용*/
::v-deep .ur-data-grid > .ur-data-grid__table > .ur-data-grid__content  > .ur-data-grid__content__scroll-wrapper >
.ur-data-grid__content__row {
  cursor:pointer;
}
</style>
